<template>
  <footer
    class="bg-violet-500 teacher:text-white sus:bg-transparent sus:text-violet-text-negative 2nd:text-white"
  >
    <Container class="w-full items-center justify-between py-8 @container lg:flex">
      <a href="https://hep-verlag.ch" aria-label="Hep Webseite" target="_blank">
        <IconHepLogo class="mr-4 h-9 shrink-0" />
      </a>

      <menu class="grid grid-cols-2 gap-4 @[800px]:flex @[800px]:gap-1 max-lg:mt-12">
        <li
          v-for="{ page } in cms.globals?.footer?.tree"
          :key="page.id"
          class="typo-body-m-medium md:typo-body-l-semibold"
          role="menuitem"
        >
          <DynLink
            v-if="page && page.url"
            class="
              flex flex-wrap ring-focusTeacher transition
              hover:text-violet-100
              focus:outline-none
              focus-visible:ring-2
            "
            :to="page.url"
            :aria-label="`go to ${page.title}`"
          >
            <span class="w-2.5 max-md:hidden" aria-label="hidden" />
            <span class="min-w-fit">
              {{ page.title }}
            </span>
            <span class="w-2.5 max-md:hidden" aria-label="hidden" />
          </DynLink>
        </li>
      </menu>
    </Container>
  </footer>
</template>

<script lang="ts" setup>
const cms = useCmsStore()
</script>
